import ComponentFrame from 'components/Dashboard/ComponentFrame/ComponentFrame'
import s from './ProposalsReviewTemplate.scss'
import { Link } from 'react-router-dom'

const ProposalsReviewTemplate = ({ title, subTitle = '', proposals }) => (
  <ComponentFrame title={title} subTitle={subTitle}>
    <div className={s.proposalsReviewTemplateWrapper}>
      <table>
        <thead>
          <tr>
            <th>Opportunity Name</th>
            <th>Client</th>
            <th>Opportunity Due Date</th>
          </tr>
        </thead>
        <tbody>
          {proposals.map(el => (
            <tr key={el.id}>
              <td>
                <Link to={`/opportunities/${el.dealId}/proposals`}>{el.dealName}</Link>
              </td>
              <td>
                <Link to={`/companies/${el.companyId}`}>{el.companyName}</Link>
              </td>
              <td>{el.dealDueDate}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </ComponentFrame>
)

export default ProposalsReviewTemplate
